<ng-container [formGroup]="model">
    @switch (field.input.type) {
        @case (inputType.DROPDOWN) {
            <p-select
                *ngIf="isEditable; else readOnly"
                [inputId]="field.name"
                [formControlName]="field.name"
                [attr.aria-describedby]="describedById || null"
                optionLabel="label"
                optionValue="value"
                [dataKey]="field.input.dropdownConfiguration?.valuePrimaryKey ?? 'id'"
                [options]="filteredOptions"
                styleClass="w-100"
                [style]="{ width: '100%' }"
                [attr.aria-invalid]="isInvalid">
            </p-select>
        }

        @case (inputType.DROPDOWN_SEARCH) {
            <p-select
                *ngIf="isEditable; else readOnly"
                [inputId]="field.name"
                [formControlName]="field.name"
                [attr.aria-describedby]="describedById || null"
                [virtualScroll]="true"
                [virtualScrollItemSize]="40"
                [options]="filteredOptions"
                optionLabel="label"
                optionValue="value"
                [dataKey]="field.input.dropdownConfiguration?.valuePrimaryKey ?? 'id'"
                [filter]="true"
                filterBy="label"
                styleClass="w-100"
                [style]="{ width: '100%' }"
                [attr.aria-invalid]="isInvalid">
            </p-select>
        }

        @case (inputType.MULTISELECT) {
            <p-listbox
                *ngIf="isEditable; else readOnly"
                [options]="filteredOptions"
                [filter]="filterInputParcelas"
                [metaKeySelection]="false"
                [checkbox]="true"
                [multiple]="true"
                [showToggleAll]="false"
                [dataKey]="field.input.dropdownConfiguration?.valuePrimaryKey ?? 'id'"
                [listStyle]="{
                    'max-height': field.input.dropdownConfiguration?.hasMaxHeight ? '100%' : '15rem',
                    'min-height':'18px',
                    'width': '100%'
                }"
                styleClass="w-100"
                [attr.aria-describedby]="describedById || null"
                [formControlName]="field.name"
                [attr.aria-invalid]="isInvalid">
            </p-listbox>
        }

        @case (inputType.MULTISELECT_SEARCH) {
            <p-multiselect
                *ngIf="isEditable; else readOnly"
                [options]="filteredOptions"
                [inputId]="field.name"
                [formControlName]="field.name"
                [attr.aria-describedby]="describedById || null"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                [showToggleAll]="true"
                [dataKey]="field.input.dropdownConfiguration?.valuePrimaryKey ?? 'id'"
                placeholder="Seleccionar"
                styleClass="w-100"
                [style]="{ width: '100%' }"
                [maxSelectedLabels]="2"
                [attr.aria-invalid]="isInvalid">
                <ng-template let-data #item>
                    <div class="multiselect-option-label">
                        {{ data.label }}
                    </div>
                </ng-template>
            </p-multiselect>
        }

        @case (inputType.SELECT_BUTTON) {
            <p-selectButton
                (onOptionClick)="updateModel()"
                [attr.aria-describedby]="describedById || null"
                [options]="filteredOptions"
                [multiple]="field.input.selectButtonConfiguration?.isMultiSelect"
                styleClass="w-100"
                [disabled]="field.input.selectButtonConfiguration?.isDisabled ?? false"
                [attr.aria-invalid]="isInvalid">
            </p-selectButton>
        }
    }
</ng-container>

<ng-template #readOnly>
    <app-reactive-read-only-field [field]="field" [model]="model"></app-reactive-read-only-field>
</ng-template>
